import styled from '@emotion/styled';

const ContentWrapper = styled('section')({
  display: 'flex',
});

export default ContentWrapper;
